package com.exura.features.legacyplans.domain.model

import kotlinx.datetime.LocalDateTime
import kotlinx.serialization.Serializable

@Serializable
data class TimelyRestriction(
    override val id: String,
    override var planId: String,
    override val instructionId: String,
    override val seriesId: String,
    override val startFrom: LocalDateTime,
    override val endAt: LocalDateTime,
    override val notificationId: Int,
    val title: String,
    val description: String,
    val icon: String,
) : TimelyElement
